<form #form="ngForm" class="sob-demanda-form-control-radio" novalidate>   
    <label class="col-form-label" [for]="id">{{inputLabel}}</label>
    <br/>
    <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" class="custom-control-input" [name]="name" id="{{id}}_Sim" [value]="true" [ngModel]="sobDemanda" (ngModelChange)="onChange($event)"
            #sobDemandaModel="ngModel" [required]="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">                     
        <label class="custom-control-label" for="{{id}}_Sim">Sim</label>
    </div> 
    <div class="custom-control custom-radio custom-control-inline">
        <input type="radio" class="custom-control-input" [name]="name" id="{{id}}_Nao" [value]="false" [ngModel]="sobDemanda" (ngModelChange)="onChange($event)"
            required="required" [attr.disabled]="canEdit == false || null" [attr.readonly]="canEdit == false || null">                     
        <label class="custom-control-label" for="{{id}}_Nao">Não</label>
    </div> 
    <sgt-form-control-error
        *ngIf="sobDemandaModel.errors && sobDemandaModel.errors.required && sobDemandaModel.dirty"
        [msgError]="msgRequiredError">
    </sgt-form-control-error>   
    <p class="form-text text-muted">
        {{inputHelpText}}
    </p>
</form>
